'use client';

import {Center} from '@linx-security/ui';
import type {FC} from 'react';

import {Spinner} from '../../_components/Spinner';

const Loading: FC = () => {
  return (
    <Center userSelect={`none`} width={`full`} height={`full`} minH={`180px`}>
      <Spinner />
    </Center>
  );
};

export default Loading;
